import {CAlert} from "@coreui/react";
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  render() {
    if (this.state.hasError) {
      return (<CAlert color="danger" closeButton>
        Oops, search returned too many results! Refresh page to start over.
      </CAlert>);
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
